import ApiRequestProvider from 'services/common/api-request/request-provider.js';
import PdfUtils from './utils';
import MojitoCore from 'mojito/core';

const PDF_API_PATH = '/pdf/generate';
const log = MojitoCore.logger.get('PdfService');

/**
 * PDF Service.
 *
 * @class PdfService
 * @name pdfService
 * @memberof Mojito.Services.Pdf
 */
class PdfService {
    init(pdfServiceUrl) {
        this.pdfServiceBaseUrl = pdfServiceUrl;
        this.requestFactory = new ApiRequestProvider(log);
    }

    /**
     * Downloads a betting receipt.
     *
     * @param {Array<object>} bets - Formatted bets list.
     * @param {object} labels - The labels map to be included in the receipt.
     *
     * @returns {Promise} Promise resolves on PDF service response.
     * @function Mojito.Services.Pdf.pdfService#downloadBetReceipt
     */
    downloadBetReceipt(bets, labels) {
        if (!this.pdfServiceBaseUrl) {
            log.error('No pdf service configured!');
            return Promise.reject();
        }

        const pdfRequest = PdfUtils.buildPdfRequest(bets, labels);

        return this.requestFactory
            .post(this.pdfServiceBaseUrl + PDF_API_PATH)
            .withCredentials()
            .withRawBodyResponse()
            .send(pdfRequest);
    }
}

export default new PdfService();
